
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'RefreshIcon',
  props: {
    eyeType: {
      type: String,
      default: 'on'
    }
  },
  computed: {
    ...mapGetters([
      'global',
    ]),
  },
});
